class CreateRoomCommand {

    constructor({ roomName, isPrivateRoom, oppositeUserId, currentUserId }) {
        this.roomName=roomName;
        this.isPrivateRoom=isPrivateRoom;
        this.oppositeUserId=oppositeUserId;
        this.currentUserId=currentUserId;
    }
}

export default CreateRoomCommand;



// WEBPACK FOOTER //
// ./src/platform/chat/model/CreateRoomCommand.js